// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import OrganizationEditScreen from "../../../src/screens/organizations/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} OrganizationEditRouteProps */

/** @typedef {Record<string, never>} OrganizationEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<OrganizationEditRouteProps, OrganizationEditRouteState>}
 */
class OrganizationEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit organization")}</ScreenTitle>
        <OrganizationEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<OrganizationEditRouteProps>} */
const OrganizationEditRouteComponent = memo(shapeComponent(OrganizationEditRoute))

export default OrganizationEditRouteComponent
